import schema, {
  thirdPartyMap,
} from "@/react/features/vcc/sms-channels/schema";
import React from "react";
import { cellErrors } from "@/react/components/table/useTableMutations";
import { PhoneNumberSelectorCell } from "@/react/features/vcc/sms-channels/PhoneNumberSelectorCell";
import { PhoneNumberManualCell } from "@/react/features/vcc/sms-channels/PhoneNumberManualCell";
import FullWidthDiv from "@/react/features/styled/FullWidthDiv";
import { ValidationWrapper } from "@/react/components/table/components";

export function PhoneNumberCell(phoneCell) {
  const errors = cellErrors(phoneCell);

  const thirdPartyCell = phoneCell.row
    .getAllCells()
    .find((c) => c.column.id === schema.fields.thirdParty.spec.key)
    ?.getContext();

  const isManualPhoneNumberEntry = [
    thirdPartyMap.TWILIO,
    thirdPartyMap.WAVECELL,
  ].includes(thirdPartyCell?.getValue());

  return (
    <FullWidthDiv>
      <ValidationWrapper errors={errors}>
        {isManualPhoneNumberEntry ? (
          <PhoneNumberManualCell {...phoneCell} />
        ) : (
          <PhoneNumberSelectorCell {...phoneCell} />
        )}
      </ValidationWrapper>
    </FullWidthDiv>
  );
}
